<template>
  <div>
    <v-dialog
      v-model="isOpenDialog"
      max-width="600"
      width="auto"
      persistent
      :attach="'.createPostBtnWrapper'"
    >
      <v-card class="px-md-8 px-4 py-3">
        <v-row no-gutters justify="space-between">
          <div class="d-flex align-center flex-wrap mb-6 mr-3">
            <h2 class="page-title">
              {{ modalHeader() }}
            </h2>
          </div>
          <v-btn icon class="rounded-circle gray6 buttonClose" @click="closeDialog">
            <v-icon class="fal fa-xmark"></v-icon>
          </v-btn>
        </v-row>
        <v-row class="pb-10 formPost" no-gutters>
          <v-col cols="12">
            <AutoForm
              v-if="entity"
              :layout="layout"
              :model="entity"
              ref="form"
            />

            <v-btn
              color="primary"
              block
              height="47"
              class="text-none font-weight-bold text-h6 mt-6"
              @click="onSubmit()"
              :loading="isLoadingBtn"
            >
              <v-icon class="fas fa-cloud-arrow-up pr-3"></v-icon>
              <translate>Post</translate>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import AutoForm from "@/components/Forms/AutoForm";
import PostForm from "@/forms/PostForm";

export default {
  name: "ModifyPost",
  props: {
    postType: {
      type: Number,
    },
    courseId: {
      type: Number,
    },
    isGolfCourse: { type: Boolean, default: false },
  },
  components: {
    AutoForm,
  },
  data() {
    return {
      entity: {
        type: this.postType,
        isGolfCourse: this.isGolfCourse, //is golf course page
      },
      isOpenDialog: false,
      isLoadingBtn: false,
      count: 0,
    };
  },
  computed: {
    layout() {
      return PostForm.layout(this.entity);
    },
    currentPost() {
      return this.$store.state.post.currentPost;
    },
  },
  watch: {
    currentPost(value) {
      if (value && value.id) {
        this.resetForm();
        this.entity = JSON.parse(JSON.stringify(value));
        this.isOpenDialog = true;
      }
    },
  },
  methods: {
    modalHeader() {
      if(this.entity.id) {
        if (this.postType === POST_TYPE_DISCUSSION) {
          return this.$gettext('Edit Discussion')
        }
        return this.$gettext("Edit post")
      }
      if (this.postType === POST_TYPE_DISCUSSION) {
        return this.$gettext('Create Discussion')
      }
      return this.$gettext("Create post")
    },
    closeDialog() {
      this.$store.state.post.currentPost = {};
      this.$refs.form.clearForm();
      this.entity = {
        type: this.entity.type,
      };
      this.isOpenDialog = !this.isOpenDialog;
    },
    resetForm() {
      this.entity = Object.assign({}, PostForm.defaultEntity);
      //is post course home
      if (this.postType === POST_TYPE_COURSE_POST) {
        this.entity.type = POST_TYPE_COURSE_POST;
      }
      //is post course media
      if (this.postType === POST_TYPE_COURSE_MEDIA) {
        this.entity.type = POST_TYPE_COURSE_MEDIA;
      }

      //is post course media
      if (this.postType === POST_TYPE_DISCUSSION) {
        this.entity.type = POST_TYPE_DISCUSSION;
      }
    },
    ...mapActions("post", {
      newPost: "newPost",
      updatePost: "updatePost",
    }),
    parseFormData(input) {
      //filter
      let data = { ...input };
      if(data.content) {
        data.content = data.content.replace(/<p><\/p>/g, '')
      }

      //coaching no have course
      if (!data.type) {
        data.type = POST_TYPE_POST;
        delete data.course;
      } else {
        if (data.course) data.course = data.course.id;
        else {
          delete data.course;
        }
      }

      if (this.postType == POST_TYPE_COACH) {
        data.type = POST_TYPE_COACH;
      }

      //is post course home
      if (this.postType === POST_TYPE_COURSE_POST) {
        data.type = POST_TYPE_COURSE_POST;
        data.course = this.courseId;
      }

      //is post course vlog
      if (this.postType === POST_TYPE_VLOG) {
        if (!data.course) data.course = this.courseId;
      }

      //is post course media
      if (this.postType === POST_TYPE_COURSE_MEDIA) {
        data.type = POST_TYPE_COURSE_MEDIA;
        data.course = this.courseId;
        data.language = 30;
        data.content = " ";
      }

      //is post discussions
      if (this.postType === POST_TYPE_DISCUSSION) {
        data.type = POST_TYPE_DISCUSSION;
      }

      if (data.language && data.language.id) {
        data.language = data.language.id;
      }

      delete data.reviewData;
      const formData = new FormData();

      if (this.currentPost && this.currentPost.photos) {
        this.currentPost.photos.forEach((photo) => {
          if (!photo.id) return;
          const survivedPhoto = data.photos.find((p) => {
            return p.id && p.id == photo.id;
          });
          if (survivedPhoto) {
            if (survivedPhoto.title !== photo.title) {
              formData.append(
                "reTitledMedia[]",
                survivedPhoto.id + "reTitledMedia" + survivedPhoto.title
              );
            }
          } else {
            formData.append("removedMedia[]", photo.id);
          }
        });
      }

      if (this.currentPost && this.currentPost.youtubes) {
        this.currentPost.youtubes.forEach((youtube) => {
          if (!youtube.id || !data.youtubes) return;
          const survivedYoutube = data.youtubes.find((y) => {
            return y.id && y.id == youtube.id;
          });
          if (!survivedYoutube) {
            formData.append("removedMedia[]", youtube.id);
          }
        });
      }

      //parse
      for (let i in data) {
        if (i === "photos") {
          data.photos.forEach((photo) => {
            if (!photo.id) {
              formData.append("photoFiles[]", photo.file);
              formData.append("photoTitles[]", photo.title);
            }
          });
        } else if (i === "youtubes") {
          data.youtubes.forEach((youtube) => {
            if (!youtube.id) {
              formData.append("youtubes[]", youtube);
            }
          });
        } else if (i === "hashtags") {
          if (data.hashtags) {
            data.hashtags.forEach((hashtag) => {
              formData.append("hashtags[]", hashtag);
            });
          }
        } else {
          formData.append(i, data[i]);
        }
      }
      return formData;
    },
    async submitData() {
      const data = this.parseFormData(this.entity);
      delete this.entity.photos; //remove after submit
      if (!this.entity.id) {
        const result = await this.newPost(data);
        this.$emit("postCreated", result);
        this.$store.dispatch("setTotalPost", +1); //set +/- posts of user
        this.resetForm()
      } else {
        const result = await this.updatePost(data);
        this.$emit("postUpdated", result);
        delete this.entity.id;
      }
      this.$root.$emit("postSubmit");
      this.$refs.form.clearForm();
      this.isLoadingBtn = false;
      this.isOpenDialog = false;
    },
    async onSubmit() {
      this.isLoadingBtn = true
      if (this.$refs.form.validate()) {
        if(this.postType === POST_TYPE_DISCUSSION) {
          let trimStr = ''
          if(this.entity.content) {
            const str = JSON.parse(JSON.stringify(this.entity.content))
            trimStr = str ? str.replace(/[<p></p>]/g,'').trim() : ''
          }
          if(trimStr) {
            await this.submitData()
          } else {
            const result = await this.$store.state.toggle.dialogConfirm.open(
              this.$gettext("Description is empty"),
              this.$gettext("Please enter your description"),
              { color: "warning" },
              false, true
            );
            if(!result) {
              this.isLoadingBtn = false;
              return
            } else {
              await this.submitData()
            }
          }
        } else {
          await this.submitData()
        }
      }
      this.isLoadingBtn = false;
    },
  },
};
</script>

<style lang="scss">
.radio-col-4 {
  flex-direction: row;
  .v-input--radio-group__input {
    flex-direction: row;
    .v-radio {
      width: 32%;
    }
  }
}
.buttonClose {
  cursor: pointer;
  width: 33px;
  height: 33px;
  text-align: center;
  padding-top: 3px;
  padding-left: 2px;
}
</style>
